// 数据词典
// 效力状态：0-失效、1-有效、2-废止
export const effectFlag = (value) => {
  if (value === '0') {
    return '失效'
  } else if (value === '1') {
    return '有效'
  } else {
    return '废止'
  }
}
// 解读类型：0-部门解读、1-媒体解读、2-其他
export const interpretationTypeFlag = (value) => {
  if (value === '0') {
    return '部门解读'
  } else if (value === '1') {
    return '媒体解读'
  } else {
    return '其他'
  }
}
// 解读方式：0-图文方式、1-文字方式、2-视频方式、3-动漫方式、4-音频方式、5-在线访谈方式、6-新闻发布会方式
export const readingWayFlag = (value) => {
  if (value === '0') {
    return '图文方式'
  } else if (value === '1') {
    return '文字方式'
  } else if (value === '2') {
    return '视频方式'
  } else if (value === '3') {
    return '动漫方式'
  } else if (value === '4') {
    return '音频方式'
  } else if (value === '5') {
    return '在线访谈方式'
  } else {
    return '新闻发布会方式'
  }
}
// 事项类型：01-行政许可、02-行政处罚、03-行政强制、04-行政征收、05-行政给付、06-行政检查、07-行政确认、08-行政奖励、09-行政裁决、10-其他行政、20-公共服务
export const taskTypeFlag = (value) => {
  if (value === '01') {
    return '行政许可'
  } else if (value === '02') {
    return '行政处罚'
  } else if (value === '03') {
    return '行政强制'
  } else if (value === '04') {
    return '行政征收'
  } else if (value === '05') {
    return '行政给付'
  } else if (value === '06') {
    return '行政检查'
  } else if (value === '07') {
    return '行政确认'
  } else if (value === '08') {
    return '行政奖励'
  } else if (value === '09') {
    return '行政裁决'
  } else if (value === '10') {
    return '其他行政'
  } else {
    return '公共服务'
  }
}